import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-dc-request-card',
    templateUrl: './dc-request-card.component.html',
    styleUrls: ['./dc-request-card.component.scss'],
    standalone: false
})
export class DcRequestCardComponent implements OnChanges {
  @Input() value: string;
  @Input() requestType: string;
  @Input() cardColour: string;
  @Input() actionOwner: string;
  @Input() activeFilter: string;

  viewHoverText = false;

  constructor() {}

  ngOnChanges() {}
}
